import { SidebarProvider } from "@/components/ui/sidebar";
import { DashboardSidebar } from "@/components/DashboardSidebar";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { FundraisingTab } from "@/components/sales/FundraisingTab";

export default function LeverDesFondsPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) navigate("/auth");
  }, [loading, user, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return null;

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <DashboardSidebar />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-6">
            <div className="mb-5">
              <h1 className="text-2xl md:text-3xl font-bold" data-testid="fundraising-title">Lever des fonds</h1>
              <p className="text-sm text-muted-foreground mt-1">
                Fonds pré-seed matchés sur ton profil, plateformes de financement, dossiers Bpifrance. Tout pour financer ta croissance.
              </p>
            </div>
            <FundraisingTab />
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
